// extracted by mini-css-extract-plugin
export default {"catHolder":"work_catHolder__3gh1Y","descHolder":"work_descHolder__bTZUg","proHolder":"work_proHolder__L0AyP","gridOrFlex":"work_gridOrFlex__CEn8Y","spacer":"work_spacer__9ljgh"};